import { trellisPalette } from "../../custom/analytics/palettes";
import type { CSSProperties, ReactNode } from "react";

interface Props {
  progress: number;
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
  label?: ReactNode;
}

const ProgressBar = ({ progress, width = "130px", height = "12px", label = "" }: Props) => {
  return (
    <div className="text-center">
      <div
        style={{
          position: "relative",
          width: width,
          height: height,
          borderRadius: "3px",
          backgroundColor: "rgba(221, 221, 221, .75)",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: `${progress}%`,
            height: height,
            borderRadius: "3px",
            backgroundColor: trellisPalette[2],
          }}
        />
      </div>
      {label && (
        <small className="d-block" style={{ fontSize: "10px" }}>
          {label}
        </small>
      )}
    </div>
  );
};

export default ProgressBar;
